import request from '@/common/api'
import { HOSTS } from '@/common/utils/env'

/** 部门树节点 */
export interface IDepartmentTreeNode {
  /** 部门 ID */
  id: number;
  /** 部门名称 */
  name: string;
  /** 上级部门 ID */
  parentId: number;
  /** 名称链，如「总部/研发部」 */
  namePath: string;
  /** 员工数（含子部门） */
  staffCount: number;
  /** 子部门列表 */
  children?: IDepartmentTreeNode[];
  /** 搜索命中标记：true 表示该节点或其子节点命中搜索词，应展开 */
  matched?: boolean;
}

export interface IDepartmentTreePageResult {
  pageNo: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  result: IDepartmentTreeNode[];
}

/** 查询部门树（分页） */
export const fetchDepartmentTree = async (params?: { keyword?: string; pageNo?: number; pageSize?: number; searchMode?: string }) => {
  try {
    const data = await request.get<IDepartmentTreePageResult>(
      `${HOSTS.BASE}/api/entweb/department/tree`,
      { params: { pageSize: 20, ...params } }
    )
    return { success: true, data }
  } catch (error) {
    return { success: false, error }
  }
}

/** 创建部门接口冲突项 */
export interface IDeptConflictItem {
  name: string;
  parentId: number;
  existingId?: number;
}

/** 创建部门接口响应体（原返回 Boolean，现返回对象） */
export interface ICreateDepartmentResult {
  /** 冲突列表：空数组表示无冲突已创建成功；非空表示存在重名冲突未创建 */
  conflictList: IDeptConflictItem[];
}

/** 创建部门（支持批量，入参为 list） */
export const createDepartment = async (params: {
  departmentCreateList: { name: string; parentId?: number }[];
}) => {
  try {
    const data = await request.post<ICreateDepartmentResult>(
      `${HOSTS.BASE}/api/entweb/department/create`,
      params
    )
    return { success: true, data }
  } catch (error) {
    return { success: false, error }
  }
}

/** 编辑部门 */
export const updateDepartment = async (params: {
  departmentId: number;
  name: string;
}) => {
  try {
    const data = await request.post(
      `${HOSTS.BASE}/api/entweb/department/update`,
      params
    )
    return { success: true, data }
  } catch (error) {
    return { success: false, error }
  }
}

/** 删除部门 */
export const deleteDepartment = async (params: {
  departmentId: number;
}) => {
  try {
    const data = await request.post(
      `${HOSTS.BASE}/api/entweb/department/delete`,
      params
    )
    return { success: true, data }
  } catch (error) {
    return { success: false, error }
  }
}
